"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MovePlayed_1 = require("../Actions/MovePlayed");
var MoveUndone_1 = require("../Actions/MoveUndone");
var StartRematch_1 = require("../Actions/StartRematch");
var EjectPlayer_1 = require("../EjectPlayer");
var GiveUp_1 = require("../GiveUp");
var PlayTutorialMoves_1 = require("../Tutorial/PlayTutorialMoves");
function gameMiddleware(api) {
    return function (store) { return function (next) { return function (action) {
        switch (action.type) {
            case MovePlayed_1.MOVE_PLAYED:
                if (!action.local) {
                    api.play(action.move);
                }
                break;
            case MoveUndone_1.MOVE_UNDONE:
                api.undo(action.playerActionIndex);
                break;
            case StartRematch_1.START_REMATCH:
                if (!action.rematchNotification) {
                    api.rematch().then(function (notification) { return store.dispatch(StartRematch_1.startRematch(notification)); });
                }
                break;
            case EjectPlayer_1.EJECT_PLAYER:
                api.eject(action.playerId);
                break;
            case GiveUp_1.GIVE_UP:
                api.giveUp();
                break;
            case PlayTutorialMoves_1.PLAY_TUTORIAL_MOVES:
                api.playTutorialMoves(action.quantity);
                break;
        }
        return next(action);
    }; }; };
}
exports.default = gameMiddleware;
//# sourceMappingURL=gameMiddleware.js.map